// extracted by mini-css-extract-plugin
export var banner = "_hs-0";
export var closeButton = "_hs-2";
export var greenCheckmark = "_hs-3";
export var hereLink = "_hs-4";
export var titleIcon = "_hs-1";